import styled from '@emotion/styled';
import Slider from 'react-slick';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  marginBottom: 40,
  paddingBottom: 25,
});

export const Slides = styled(Slider)({
  marginTop: 30,
  width: '100vw',
  marginLeft: 0,
});
